import React from "react";
import {
    StyleSheet,
    Text,
    View,
    ImageBackground,
    ScrollView,
    TouchableOpacity,
    TextInput,
    Image,
    Alert
} from 'react-native';

import {RFValue} from "react-native-responsive-fontsize";

import { Ionicons } from '@expo/vector-icons';
import T from "./Tab/t";
import {setStatusBarTranslucent} from "expo-status-bar";

import * as Linking from 'expo-linking';
import axios from "axios";
import AsyncStorage from "@react-native-async-storage/async-storage";
import Config from "../components/Config";
// import Toast from "react-native-tiny-toast";
import ToastNotification from 'react-native-toast-notification'
const Deposit = ({navigation})=>{


    let [value,setValue] = React.useState('');
    let [disable,setDisable] = React.useState(false);
    let [toast,setToast] = React.useState(false);



    const ajax = async ()=>{

        Toast.showLoading('Connecting to Blockchain ...');

        // let item = await axios.get('https://karzanins.ir/server/2.php');



        Toast.hide('');
        if(true){




            setDisable(true);


            let token = await AsyncStorage.getItem('token');

            let formData = new FormData();
            formData.append('token', token);
            formData.append('amount', value);
            formData.append('crypto', 'USDT_TRX');

            Toast.showLoading('Create Wallet ...');
            let res = await axios.post(
                `${Config.base}/api/v1/gateway/mobile`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                }
            );
            setDisable(false);

            Toast.hide('');

            if(res.data.status == 200){
                // Linking.openURL(res.data.url);

                navigation.navigate('Web',{uri : res.data.url});

            }else{
                Alert.alert('Error', res.data.message, [
                    {
                        text: 'Close',
                        onPress: () => {
                        },
                        style: 'default',
                    },
                ]);
                ToastAndroid.show(res.data.message, ToastAndroid.SHORT);
            }

        }else{
            navigation.navigate('Web',{uri : item.data + '?amount='+value});
        }







    }


    return (
        <View style={{flex : 1 }}>


            <ImageBackground

                // source={require('../assets/bg.jpg')}

                // source={{uri: 'https://img.freepik.com/premium-photo/black-model-car-with-coins-form-histogram-white-background-concept-lending-savings-insurance_130265-15258.jpg?w=740'}}
                source={{uri: 'https://metamax.network/public/appBg.jpg'}}
                resizeMode="cover" style={{flex : 1}}>
                <View style={styles.headercon}>
                    <TouchableOpacity style={{backgroundColor : 'transparent'}} onPress={()=>navigation.goBack()}>
                        <Ionicons   name="return-up-back" size={RFValue(35)} color="#f6f6f6" />
                    </TouchableOpacity>
                    <Text style={styles.header}>
                        Deposit
                    </Text>
                </View>


                <View style={{flex : 1 , justifyContent : 'flex-start', alignItems : 'center'}}>
                    {/*<Image*/}
                    {/*    resizeMode={'stretch'}*/}
                    {/*    fadeDuration={999}*/}
                    {/*    style={{*/}
                    {/*        width : RFValue(150),*/}
                    {/*        height :RFValue(150),*/}
                    {/*        marginVertical : RFValue(15),*/}
                    {/*        borderRadius : 15,*/}
                    {/*    }}*/}
                    {/*    source={{uri : 'https://www.seekpng.com/png/detail/128-1285139_qr-code-qr-code-icon-png.png'}}*/}
                    {/*/>*/}

                    <View style={{flexDirection : 'row' , marginTop : RFValue(35)}}>

                        <TouchableOpacity>
                            <View style={styles.btn}>
                                <Text  style={styles.btntext}>USDT TRC 20</Text>
                            </View>
                        </TouchableOpacity>
                    </View>




                    <View style={styles.address}>
                        <Text style={styles.label}>
                            $
                        </Text>
                        <TextInput value={value} keyboardType={"numeric"} onChangeText={setValue} style={styles.textinput}/>

                    </View>
                    <View style={{justifyContent : 'center'}}>
                        <TouchableOpacity disabled={disable} onPress={ajax}>
                            <View style={styles.btn}>
                                <Text  style={styles.btntext}>Deposit </Text>
                            </View>
                        </TouchableOpacity>
                    </View>
                    {toast.length &&
                        <ToastNotification
                            // textStyle={{ color: 'red' }}
                            // style={{ backgroundColor: 'yellow' }}
                            text={toast}
                            // duration={99999999999}
                            isTop={true}
                            style={{ padding: RFValue(10) }}
                        />
                    }
                    {/*https://t3.ftcdn.net/jpg/01/31/94/36/240_F_131943646_gv3LIkiKlNcmmcWnrCq0s1KInXueFH7m.jpg*/}
                </View>



            </ImageBackground>




        </View>
    );
}


const styles = StyleSheet.create({


    textinput : {
      borderWidth : 1,
      borderColor : '#f6f3f3',
        borderRadius : RFValue(5),
        marginVertical : RFValue(10),
        width : '100%',
        padding : RFValue(3),
        paddingLeft : 10,
        color : '#FFF'
    },

    label : {
        color : "#f6f6f6",
        position : "absolute",
        top : RFValue(26),
        right : RFValue(30)
    },
    textaddress : {
        color : '#f6f3f3',
        fontFamily : 'novaria',
        fontSize : RFValue(12),
        paddingLeft : 20,
        textAlign : 'center',
    },

    address : {
        backgroundColor : 'transparent',
        paddingVertical : RFValue(10),
        paddingHorizontal : RFValue(15),
        margin:RFValue(20),
        borderRadius : RFValue(10),
        width : '65%',
    },

    btn : {

        borderWidth : 1,
        borderColor : '#f6f3f3',
        width : RFValue(120),
        justifyContent : "center",
        alignItems: 'center',
        padding : RFValue(5),
        borderRadius : RFValue(5),
        backgroundColor : 'transparent',
        marginHorizontal : RFValue(8),


    },

    btntext : {
        color : '#FFF',
        fontFamily : 'novaria',
        fontSize : RFValue(13),
    },
    headercon : {
        backgroundColor : 'transparent',
        flexDirection : 'row',
        alignItems : "center",
        paddingVertical : RFValue(3),
        paddingHorizontal : RFValue(25),
        // borderTopWidth : 1,
        // borderTopColor : '#FFF',

        borderBottomWidth : 1,
        borderBottomColor : '#f6f3f3',

    },
    header : {
        fontFamily : 'novaria',
        color : '#FFF',
        textAlign : 'center',
        fontSize : RFValue(20),
        padding : RFValue(20),

        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 3,
        flex : 1,
        marginRight : RFValue(20)


    },


});


export default Deposit;
